import { render, staticRenderFns } from "./AlertTemplate.vue?vue&type=template&id=006ffe05&lang=html"
import script from "./AlertTemplate.vue?vue&type=script&lang=js"
export * from "./AlertTemplate.vue?vue&type=script&lang=js"
import style0 from "./AlertTemplate.vue?vue&type=style&index=0&id=006ffe05&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CloseButton: require('/var/www/malayan/web/components/global/CloseButton.vue').default})
